<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.programs") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn :to="{ name: 'create_program' }" class="primary">
        <span>{{ $t("button.create") }}</span>
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <global-search-filter :queries="queries" ref="search_filter_ref" />
    <v-row no-gutters>
      <v-col cols="12" sm="4">
        <global-toggle-filter
          :queries="toggleQueryies"
          ref="toggle_filter_ref"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn large @click="ClearAllFilters" class="error">{{
          $t("button.reset")
        }}</v-btn>
      </v-col>
    </v-row>
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="programs"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          <v-avatar size="40">
            <v-img
              @click="$refs.table_ref.handleImagePreview(item.main_image)"
              class="hover-pointer"
              aspect-ratio="1"
              :src="
                item.main_image
                  ? item.main_image.path
                  : '@/assets/imgs/user.jpg'
              "
            ></v-img>
          </v-avatar>
        </td>
        <td class="text-sm-center">
          {{ item ? item.name : "" }}
        </td>
        <td class="text-sm-center">
          {{ item.price }}
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="program"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <span :title="item.description">{{
            item.description | truncate
          }}</span>
        </td>
        <td class="text-sm-center">
          <router-link
            :to="{ name: 'edit_program', params: { slug: item.slug } }"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </router-link>

          <v-icon
            :title="$t('icon.delete')"
            @click="handleDelete(item, index)"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
    </wrapping-table>
  </main>
</template>
<script>
export default {
  name: "Programs",
  data() {
    return {
      headers: [
        "photo",
        "name",
        "price",
        "visibility",
        "description",
        "actions"
      ],
      queries: {
        query: {
          name: ""
        }
      },
      toggleQueryies: {
        query: {
          visible: ""
        }
      }
    };
  },
  methods: {
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    },
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    }
  }
};
</script>
